import axios from 'axios'
import i18n from '@/locales'
import { API_BASE_URL } from '../config'
import store from '@/store'
import { getToken, getLanguage } from '@/utils/cache'
import packageInfo from '../../package.json'
import { countersign, visaVerification } from '@/utils/signature'

const layer = window.layer
const $ = window.$

// 请求跨域代理设置
let requestPrefix = API_BASE_URL
if (process.env.VUE_APP_MODE == 'dev') {
  requestPrefix = '/proxy'
}
// 获取当前时区
const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
//query上加lang参数，暂时没有用
// const updateQueryStringParameter = (url, key, value) => {
//   if (!value) {
//     return url;
//   }
//   let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
//   let separator = url.indexOf("?") !== -1 ? "&" : "?";
//   if (url.match(re)) {
//     return url.replace(re, "$1" + key + "=" + value + "$2");
//   } else {
//     return url + separator + key + "=" + value;
//   }
// };
//获取zh或en之后变成后端需要的请求头格式`zh-cn`, `en-us
const language = () => {
  if (getLanguage() === 'zh') {
    return 'zh-cn'
  } else if (getLanguage() === 'en') {
    return 'en-us'
  } else if (getLanguage() === 'ru') {
    return 'ru-ru'
  } else if (getLanguage() === 'ar') {
    return 'ar-sa'
  } else if (getLanguage() === 'fr') {
    return 'fr-fr'
  } else if (getLanguage() === 'es') {
    return 'es-es'
  } else if (getLanguage() === 'id') {
    return 'id-id'
  } else if (getLanguage() === 'hu') {
    return 'hu-hu'
  } else if (getLanguage() === 'de') {
    return 'de-de'
  } else if (getLanguage() === 'vi') {
    return 'vi-vn'
  } else if (getLanguage() === 'th') {
    return 'th-th'
  } else if (getLanguage() === 'mn') {
    return 'mn-mn'
  } else if (getLanguage() === 'ko') {
    return 'ko-kr'
  } else if (getLanguage() === 'ja') {
    return 'ja-jp'
  } else if (getLanguage() === 'bg') {
    return 'bg-bg'
  }
}

//新接口请求封装
export const apiRequest = axios.create()
const version = packageInfo.version
let loadIndex1
apiRequest.defaults.headers.post['Content-Type'] = 'application/json'
apiRequest.defaults.headers.post['Device-Type'] = 'H5'
apiRequest.defaults.headers.common['Time-Zone'] = timeZone
apiRequest.defaults.headers.common['Accept-Language'] = language() || 'zh-cn'
apiRequest.defaults.headers.common['Client-Version'] = version
apiRequest.defaults.timeout = 60000
apiRequest.defaults.baseURL = requestPrefix
apiRequest.interceptors.request.use(
  (config) => {
    // config.url = updateQueryStringParameter(config.url, "lang", language() || "zh-cn");
    // console.log("请求配置=====", config);
    if (config.loading == true) {
      loadIndex1 = layer.load(3)
    }
    let token = getToken()
    const signKeyData = countersign(config.url, config.method, config.data || config.params)
    if (signKeyData) {
      config.headers['timestamp'] = signKeyData?.timestamp
      config.headers['nonce'] = signKeyData?.randomString
      config.headers['sign'] = signKeyData?.signKey
    }

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)
apiRequest.interceptors.response.use(
  function (response) {
    layer.close(loadIndex1)
    const responseHeader = response.headers
    const errcode = response.data.errcode
    const isPass = visaVerification(responseHeader?.timestamp, responseHeader?.nonce, responseHeader?.sign, response.request?.response)
    if (isPass && isPass == 'no_pass') {
      return new Error('验签不通过！')
    }
    if (errcode === 0 || errcode === 3007) {
      return response.data
    } else if (1000 <= Number(errcode) && 2000 >= Number(errcode)) {
      // 弹窗：退出登录
      // TokenError 1001 无效的 token，请重新登陆
      store.dispatch('user/handleLogout', { reLogin: true })
      return
    } else {
      const errmsg = response.data.errmsg || 'Unknown Error'
      return Promise.reject(errmsg)
    }
  },
  function (error) {
    layer.close(loadIndex1)
    return Promise.reject(error)
  }
)

export const utilV2 = {
  allReq: new Map(),
  networkErrorHandler: function (msg, cb, tryAgian) {
    layer.open({
      title: '',
      closeBtn: 0,
      content: msg,
      btn: [i18n.tc('button_common_ok'), i18n.tc('button_common_start_over')],
      yes: function () {
        layer.closeAll()
        cb && cb()
      },
      btn2: function () {
        tryAgian && tryAgian()
      },
    })
  },
  hasHttp: function (url) {
    if (url.indexOf('http://') != -1 || url.indexOf('https://') != -1) {
      return true
    } else {
      return false
    }
  },
  abortAllReq: function () {
    utilV2.allReq.forEach(function (value, key) {
      value.abort()
      utilV2.allReq.delete(key)
    })
  },
  getJSON: function (action) {
    var result = arguments[1] || null
    var fail = arguments[2] || null
    var config = arguments[3] || null
    var index
    var jp = $.ajax(action, {
      headers: {
        'Accept-Language': language() || 'zh-cn',
      },
      type: 'GET',
      dataType: 'json',
      cache: false,
      beforeSend: function (request, xhr) {
        // xhr.url = updateQueryStringParameter(xhr.url, "lang", language() || "zh-cn");
        if (!config || (config && config.showLoading === true)) {
          index = layer.load(3)
        }
      },
      complete: function () {
        layer.close(index)
      },
      success: function (data) {
        result && result(data)
      },
      error: function () {
        layer.open({
          title: '',
          closeBtn: 0,
          content: i18n.tc('common_text_file_error'),
          btn: ['OK'],
          yes: function (index) {
            layer.close(index)
            fail && fail()
          },
        })
      },
    })
    return jp
  },
  getData: function (action) {
    var formdata = arguments[1] || null,
      result = arguments[2] || null,
      fail = arguments[3] || null,
      networkError = arguments[5] || null,
      index
    var config = Object.assign(
      {
        dataType: 'json',
        showLoading: true,
      },
      arguments[4] || {}
    )
    var url
    if (this.hasHttp(action)) {
      url = action
    } else {
      url = requestPrefix + action
    }
    const signKeyData = countersign(action, 'get', formdata)
    // console.log("旧请求配置get===", url, formdata);
    var jp = $.ajax(url, {
      headers: {
        'Device-Type': 'H5',
        'Time-Zone': timeZone,
        'Accept-Language': language() || 'zh-cn',
        timestamp: signKeyData?.timestamp,
        nonce: signKeyData?.randomString,
        sign: signKeyData?.signKey,
      },
      type: 'GET',
      data: formdata,
      dataType: config.dataType,
      // async: true,
      complete: function (xhr) {
        const timestamp = xhr.getResponseHeader('timestamp')
        const nonce = xhr.getResponseHeader('nonce')
        const sign = xhr.getResponseHeader('sign')
        const isPass = visaVerification(timestamp, nonce, sign, xhr?.responseText)
        // console.log("旧响应配置get===", xhr, timestamp, nonce, sign);
        if (isPass && isPass == 'no_pass') {
          return new Error('验签不通过！')
        }
      },
      beforeSend: function (e, xhr) {
        // xhr.url = updateQueryStringParameter(xhr.url, "lang", language() || "zh-cn");
        if (config && config.showLoading === true) {
          index = layer.load(3)
        }
        let token = getToken()
        if (token) {
          e.setRequestHeader('Authorization', `Bearer ${token}`)
        }
      },
      success: function (data) {
        layer.close(index)
        utilV2.responseHandler(data, result, fail)
      },
      error: function (err) {
        var _ajax = this
        layer.close(index)
        if (networkError) {
          networkError()
          return
        }
        if (err.readyState === 0) {
          utilV2.networkErrorHandler(i18n.tc('common_text_none_network'), fail, function () {
            $.ajax(_ajax)
          })
        } else {
          utilV2.networkErrorHandler(i18n.tc('common_text_server_error'), fail, function () {
            $.ajax(_ajax)
          })
        }
      },
    })
    utilV2.allReq.set(url, jp)
    return jp
  },
  postData: function (action, formdata) {
    var result = arguments[2] || null,
      fail = arguments[3] || null,
      networkError = arguments[5] || null,
      index
    var config = Object.assign(
      {
        dataType: 'json',
        showLoading: true,
        processData: true,
        contentType: 'application/x-www-form-urlencoded',
      },
      arguments[4] || {}
    )
    const signKeyData = countersign(action, 'post', formdata, config.contentType == 'application/x-www-form-urlencoded')
    // console.log("旧请求配置post===", action, formdata);
    $.ajax(requestPrefix + action, {
      headers: {
        'Device-Type': 'H5',
        'Time-Zone': timeZone,
        'Accept-Language': language() || 'zh-cn',
        timestamp: signKeyData?.timestamp,
        nonce: signKeyData?.randomString,
        sign: signKeyData?.signKey,
      },
      type: 'POST',
      timeout: 60000,
      data: formdata,
      dataType: config.dataType,
      processData: config.processData,
      contentType: config.contentType,
      beforeSend: function (e, xhr) {
        // xhr.url = updateQueryStringParameter(xhr.url, "lang", language() || "zh-cn");
        if (config && config.showLoading === true) {
          index = layer.load(3)
        }
        let token = getToken()
        if (token) {
          e.setRequestHeader('Authorization', `Bearer ${token}`)
        }
      },
      complete: function (xhr) {
        const timestamp = xhr.getResponseHeader('timestamp')
        const nonce = xhr.getResponseHeader('nonce')
        const sign = xhr.getResponseHeader('sign')
        const isPass = visaVerification(timestamp, nonce, sign, xhr?.responseText)
        if (isPass && isPass == 'no_pass') {
          return new Error('验签不通过！')
        }
      },
      success: function (data, tatus, xhr) {
        layer.close(index)
        utilV2.responseHandler(data, result, fail, xhr)
      },
      error: function (err) {
        var _ajax = this
        layer.close(index)
        if (networkError) {
          networkError()
          return
        }
        if (err.readyState === 0) {
          utilV2.networkErrorHandler(i18n.tc('common_text_none_network'), fail, function () {
            $.ajax(_ajax)
          })
        } else {
          utilV2.networkErrorHandler(i18n.tc('common_text_server_error'), fail, function () {
            $.ajax(_ajax)
          })
        }
      },
    })
  },
  //主观评测题
  postDataForSubjectiveEvaluate: function (action, formdata) {
    var result = arguments[2] || null,
      fail = arguments[3] || null
    $.ajax(action, {
      headers: {
        'Device-Type': 'H5',
        'Time-Zone': timeZone,
      },
      type: 'POST',
      data: formdata,
      dataType: 'json',
      beforeSend: function (e, xhr) {
        let token = getToken()
        if (token) {
          e.setRequestHeader('Authorization', `Bearer ${token}`)
        }
      },
      success: function (data) {
        switch (data.error) {
          case 0:
            result && result(data)
            break
          default:
            layer.open({
              title: '',
              content: '提交失败',
              btn: ['OK'],
            })
            break
        }
      },
      error: function () {
        fail('评测主观题失败!')
      },
    })
  },
  // 统一接口响应数据处理
  responseHandler: function (response, successCallback, failCallback, xhr) {
    if (typeof response === 'object') {
      const errcode = response.errcode
      if (errcode === 0) {
        successCallback && successCallback(response.data)
      } else {
        const errmsg = response.errmsg || 'Unknown Error'
        if (1000 <= Number(errcode) && 2000 >= Number(errcode)) {
          // 弹窗：退出登录
          // TokenError 1001 无效的 token，请重新登陆
          store.dispatch('user/handleLogout', { reLogin: true })
        } else {
          if (failCallback) {
            failCallback(response)
          } else {
            layer.open({
              title: '',
              closeBtn: false,
              content: errmsg,
              btn: [i18n.tc('button_common_ok')],
              yes: function (index) {
                layer.close(index)
              },
            })
          }
        }
      }
    } else {
      utilV2.allReq.delete(this.url)
      successCallback && successCallback(response)
    }
  },
}
